import api from './client';
import type { ApiResponse, CatalogoInversor, CatalogoModulo, Concessionaria } from '@engenharia/shared';

export async function listarInversores(): Promise<CatalogoInversor[]> {
  const res = await api.get<ApiResponse<CatalogoInversor[]>>('/catalogos/inversores');
  return res.data.data!;
}

export async function listarModulos(): Promise<CatalogoModulo[]> {
  const res = await api.get<ApiResponse<CatalogoModulo[]>>('/catalogos/modulos');
  return res.data.data!;
}

export async function listarConcessionarias(): Promise<Concessionaria[]> {
  const res = await api.get<ApiResponse<Concessionaria[]>>('/catalogos/concessionarias');
  return res.data.data!;
}
